const flaggedContentDE = {
    "view": {
        "form": {
            "button": {
                "viewDetails": "Details anzeigen"
            },
            "message": {
                "releaseHasBeenAddedToWhitelist": "Release <strong>{{releaseName}}</strong> wurde zur Whitelist hinzugefügt.",
                "releaseHasFlaggedContent": "Release <strong>{{releaseName}}</strong> enthält markierte Tracks. Eine Gebühr von <strong>15 €</strong> pro markiertem Track fällt an, um es an <strong>Spotify</strong> zu liefern.<br/><br/> Klicken Sie auf die Schaltfläche unten, um Ihre Zahlung abzuschließen und fortzufahren."
            },
            "modal": {
                "header": {
                    "titleFlaggedTracksDetails": "Details zu markierten Tracks",
                    "titleFlaggedTrackPayment": "Spotify-Whitelist-Zahlung"
                },
                "body": {
                    "table": {
                        "title": "Die folgenden Tracks wurden markiert. Bitte überprüfen Sie die Details unten:",
                        "column": {
                            "name": "Trackname",
                            "flaggedArtist": "Markierter Künstler",
                            "payableAmount": "Zu zahlender Betrag",
                            "paymentStatus": "Zahlungsstatus"
                        },
                        "label": {
                            "payableAmount": "15 €",
                            "paid": "BEZAHLT",
                            "pending": "AUSSTEHEND",
                        },
                    },
                    "label": {
                        "processingPayment": "Zahlung wird verarbeitet...",
                        "paymentSuccessful": "Zahlung erfolgreich!",
                        "paymentFailed": "Zahlung fehlgeschlagen!"
                    },
                    "message": {
                        "totalPayableAmount": "Um die Lieferung Ihres Releases an <strong>Spotify</strong> abzuschließen, ist eine rückzahlbare Kaution von <strong>{{totalAmount}} €</strong> erforderlich. Bitte akzeptieren Sie die untenstehenden Bedingungen und klicken Sie auf die Schaltfläche <strong>Fortfahren</strong>, um Ihre Zahlung zu leisten.",
                        "escrowAmountAgreement": "Ich akzeptiere und erkenne an, dass ein Treuhandbetrag von <strong>{{totalAmount}} €</strong> von mir hinterlegt wird. Dieser Betrag wird bis zum <strong>Ende des Abonnements</strong> gehalten und, sofern keine Probleme auftreten, am Ende dieses Zeitraums an mich zurückerstattet. Sollte ich jedoch während dieser Zeit gegen die Bedingungen dieser Vereinbarung verstoßen, wird der Treuhandbetrag auf die ausstehende Rechnung angewendet und nicht zurückerstattet. Durch das Fortfahren bestätige ich mein Verständnis und meine Akzeptanz dieser Bedingungen.",
                        "escrowPaymentRejected": "Ich akzeptiere die Bedingungen der Treuhandzahlung nicht und erkenne dementsprechend an, dass mein Release <strong>{{releaseName}}</strong> <strong>nicht an Spotify verteilt wird</strong>.",
                        "consentRecordedSuccessfully": "Zustimmung erfolgreich aufgezeichnet!"
                    }
                },
                "button": {
                    "proceed": "Fortfahren"
                }
            }
        }
    }
}

export default flaggedContentDE;